module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_5_4.f5766553.png";